import { PageResponse } from '@/schema/page';
import Api from './api';
import { ClinicCreate, ClinicResponse } from '@/schema/clinic';

const ClinicApi = {
  getAll(page: number, size: number) {
    const params = new URLSearchParams({
      page: String(page),
      size: String(size),
    }).toString();

    return Api.get<PageResponse<ClinicResponse>>(`/clinics?${params}`);
  },

  getById(id: string) {
    return Api.get<ClinicResponse>(`/clinics/${id}`);
  },

  create(data: ClinicCreate) {
    return Api.post<number>(`/clinics`, data); // returns the created clinic ID
  },

  delete(id: string) {
    return Api.delete<void>(`/clinics/${id}`);
  },
};

export default ClinicApi;
